import { render, staticRenderFns } from "./release_block.vue?vue&type=template&id=0ef1b666&"
import script from "./release_block.vue?vue&type=script&lang=js&"
export * from "./release_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "release_block.vue"
export default component.exports